import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';

import './assets/styles.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router';
import { useMainStore } from './store';
import axios from 'axios';

import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import uk from './locales/uk.json';

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;

const messages = {en, uk};

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  legacy: false,
  globalInjection: true,
  messages,
});

axios.interceptors.request.use((config) => {
  config.headers = config.headers || {};

  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }

  const locale = i18n.global.locale.value || 'en';
  config.headers['Accept-Language'] = locale;

  return config;
});

export default i18n;

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);

const mainStore = useMainStore();
mainStore.initializeStore();

app.mount('#app');